import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import { State } from './interface'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { StoreServices } from './store'

export type AppDispatch = ThunkDispatch<State, StoreServices, AnyAction>

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<State> = useSelector
